import { onReady } from "@otto-ec/global-resources/dom";

onReady.subscribe(async () => {
    await fetch("/session-maintenance/refresh");
})
